import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeColor extends TraitRegistryItem {
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
}
